import { defineMessages } from "react-intl";

export const MESSAGES = defineMessages({
  pageTitle: {
    id: "funding-application: page title",
    defaultMessage: "Connect all your bank accounts",
  },
  pageSubtitle: {
    id: "funding-application: page subtitle",
    defaultMessage: "We use your banking data to assess your application and build your offer.",
  },
  connectionCardTitle: {
    id: "funding-application: connection card title",
    defaultMessage: "Connect your bank",
  },
  connectionCardSubtitle: {
    id: "funding-application: connection speed",
    defaultMessage: "Instant verification, usually under an hour.",
  },
  recommendedBadge: {
    id: "funding-application: recommended badge",
    defaultMessage: "Recommended",
  },
  requiredBadge: {
    id: "funding-application: required badge",
    defaultMessage: "Required",
  },
  bankLocationLabel: {
    id: "funding-application: bank location label",
    defaultMessage: "Bank location",
  },
  connectButton: {
    id: "funding-application: connect button",
    defaultMessage: "Connect with {providerName}",
  },
  connectButtonGeneric: {
    id: "funding-application: connect button generic",
    defaultMessage: "Connect",
  },
  uploadCardTitle: {
    id: "funding-application: upload title",
    defaultMessage: "Upload statements",
  },
  uploadCardSubtitle: {
    id: "funding-application: upload description",
    defaultMessage: "Can take days, may require follow-up.",
  },
  uploadAreaLabel: {
    id: "funding-application: upload statements label",
    defaultMessage: "Upload statements",
  },
  needHelpHeading: {
    id: "funding-application: need help heading",
    defaultMessage: "Need help connecting?",
  },
  footerSupportText: {
    id: "funding-application: footer support text",
    defaultMessage:
      "<a1>Invite a team member</a1> to connect on your behalf, or <a2>talk to our team</a2> for support.",
  },
  selectCountryError: {
    id: "funding-application: select country error",
    defaultMessage: "Please select a country",
  },
  platformsButton: {
    id: "funding-application: platforms button",
    defaultMessage: "Platforms",
  },
  requiredModalTitle: {
    id: "funding-application: required modal title",
    defaultMessage: "Connect a bank account to continue",
  },
  requiredModalBody: {
    id: "funding-application: required modal body",
    defaultMessage:
      "We need your banking data to assess your application. You can connect via {providerName} or upload your statements manually.",
  },
  slideoutRequirementHeading: {
    id: "funding-application: slideout requirement heading",
    defaultMessage: "Provide at least {months} months of bank statements",
  },
  slideoutRequirementSubtitle: {
    id: "funding-application: slideout requirement subtitle",
    defaultMessage: "Include bank statements from {date} onwards for every bank account associated with your business.",
  },
  slideoutWhatToIncludeHeading: {
    id: "funding-application: slideout what to include heading",
    defaultMessage: "What to include?",
  },
  slideoutRule1: {
    id: "funding-application: slideout rule 1",
    defaultMessage: "Statements must not have gaps longer than 14 days.",
  },
  slideoutRule2: {
    id: "funding-application: slideout rule 2",
    defaultMessage: "Statement must include at least one transaction within the last 14 days.",
  },
  slideoutRule3: {
    id: "funding-application: slideout rule 3",
    defaultMessage: "All accounts associated with your business.",
  },
  submitStatementsButton: {
    id: "funding-application: submit statements button",
    defaultMessage: "Submit statements",
  },
  bankAccountsConnected: {
    id: "funding-application: bank accounts connected",
    defaultMessage: "{count, plural, one {# account connected} other {# accounts connected}}",
  },
  manageAccounts: {
    id: "funding-application: manage accounts",
    defaultMessage: "Manage accounts",
  },
  connectionsPanelTitle: {
    id: "funding-application: connections panel title",
    defaultMessage: "Bank accounts",
  },
  connectionsPanelSubtitle: {
    id: "funding-application: connections panel subtitle",
    defaultMessage: "Connect all accounts associated with your business for the most accurate offer.",
  },
  connectedAccountsHeading: {
    id: "funding-application: bank connections heading",
    defaultMessage: "Bank accounts",
  },
  accountEnding: {
    id: "funding-application: bank account mask",
    defaultMessage: "···{mask}",
  },
  addAnotherAccountHeading: {
    id: "funding-application: add another account heading",
    defaultMessage: "Add another account",
  },
  addAnotherAccountSubtitle: {
    id: "funding-application: add another account subtitle",
    defaultMessage: "The more accounts you connect, the more accurate your offer will be.",
  },
  addAnotherAccountButton: {
    id: "funding-application: add another account button",
    defaultMessage: "Add another account",
  },
  doneButton: {
    id: "funding-application: done button",
    defaultMessage: "Done",
  },
  requireConnectionModalTitle: {
    id: "funding-application: require connection modal title",
    defaultMessage: "Bank connection needed",
  },
  requireConnectionModalBody: {
    id: "funding-application: require connection modal body",
    defaultMessage:
      "We need a direct bank connection to process your application. Connect your bank account to get started.",
  },
  connectBankButton: {
    id: "funding-application: connect bank button",
    defaultMessage: "Connect bank",
  },
  statementsUploadedCount: {
    id: "funding-application: statements uploaded count",
    defaultMessage: "{count, plural, one {# file uploaded} other {# files uploaded}}",
  },
  manageStatementsButton: {
    id: "funding-application: manage statements button",
    defaultMessage: "Manage statements",
  },
  countryNotListedToast: {
    id: "funding-application: country not listed toast",
    defaultMessage:
      "Direct bank connection isn't available in your selected region. Upload your bank statements to continue.",
  },
  auOpenBankingBannerTitle: {
    id: "bankconnect: au open banking banner title",
    defaultMessage: "We use Basiq to connect with Open Banking",
  },
  auOpenBankingOptIn: {
    id: "bankconnect: opt in to connect open banking",
    defaultMessage: "You may need to <b>opt-in to data sharing</b> with your bank before connecting.",
    description:
      "Pre-connection message for Australian Open Banking, informing of the requirement to enable data sharing on the bank side",
  },
  auOpenBankingDataSharingLink: {
    id: "bankconnect: data sharing help link",
    defaultMessage: "See our <a>Data Sharing Help</a> page for details.",
    description: "Link to our Data Sharing Help page",
  },
});
